<template>
  <div class="c-app">
    <!--<TheSidebar/>-->
    <CSidebar
      fixed
      :minimize="minimize"
      :show="show"
      @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    >
      <CSidebarBrand
        class="d-md-down-none"
        style="background: rgb(255, 255, 255)"
        to="/"
      >
        <!--<CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
        />-->

        <img
          class="c-sidebar-brand-full"
          src="img/backend_logo.png"
          width="150"
          alt="Apache Logo"
          size="custom-size"
          viewBox="0 0 556 134"
        />
        <img
          class="c-sidebar-brand-minimized"
          src="img/sygnet.png"
          width="60"
          height="56"
          alt="Apache Logo"
          viewBox="0 0 110 134"
        />
      </CSidebarBrand>

      <CRenderFunction flat :contentToRender="nav" />

      <!-- <CSidebarFooter to="/"> -->
      <!-- <CSidebarNavItem>
          <i class="fa fa-mouse-pointer" aria-hidden="true"></i>
          Settings
      </CSidebarNavItem>-->
      <router-link to="/settings">
        <div class="c-sidebar-nav-item mt-auto c-sidebar-nav-settings">
          <a class="c-sidebar-nav-link">
            <i class="c-sidebar-nav-icon cil-cursor"></i> Settings
          </a>
        </div>
      </router-link>
      <!-- </CSidebarFooter> -->
      <CSidebarMinimizer
        class="d-md-down-none c-brand-minimize"
        @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
      />
    </CSidebar>

    <CWrapper>
      <!--<TheHeader/>-->
      <CHeader fixed with-subheader light>
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="mx-auto d-lg-none" to="/">
          <!--<CIcon name="logo" height="48" alt="Logo"/>-->
          <img
            class="navbar-brand-full"
            src="img/backend_logo.png"
            width="150"
            height="50"
            alt="Apache Logo"
          />
          <img
            class="navbar-brand-xs"
            src="img/backend_logo.png"
            alt="Apache Logo"
          />
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CNav variant="pills" class="p-0">
            <CNavItem class="px-3" @click.native="cambiarMenu('listen')"
              >Listen</CNavItem
            >
            <CNavItem class="px-3" @click.native="cambiarMenu('analyze')"
              >Analyze</CNavItem
            >
            <CNavItem class="px-3" @click.native="cambiarMenu('action')"
              >Action</CNavItem
            >
          </CNav>
          <!--  
      <CNav variant="pill">
      <CHeaderNavItem class="px-3"  @click.native="cambiarMenu('listen')">
      <CHeaderNavLink >
          Listen 
      </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" @click.native="cambiarMenu('analyze')">
      <CHeaderNavLink  >
          Analyze
      </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" @click.native="cambiarMenu('action')">
      <CHeaderNavLink  >
          Action
      </CHeaderNavLink>
      </CHeaderNavItem>
          -->
        </CHeaderNav>
        <CHeaderNav class="mr-4">
          <!--<CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
          </CHeaderNavItem>-->
          <TheHeaderDropdownEmail />
          <TheHeaderDropdownAccnt />
        </CHeaderNav>

        <div class="px-3 mobileheaderlink">
          <CNav variant="pills" class="p-0">
            <CNavItem class="px-3" @click.native="cambiarMenu('listen')"
              >Listen</CNavItem
            >
            <CNavItem class="px-3" @click.native="cambiarMenu('analyze')"
              >Analyze</CNavItem
            >
            <CNavItem class="px-3" @click.native="cambiarMenu('action')"
              >Action</CNavItem
            >
          </CNav>
        </div>
        <CSubheader class="px-3">
          <CBreadcrumbRouter :list="list" class="border-0 mb-0" />
        </CSubheader>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<!-- <script>
// import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt';
// import TheHeaderDropdownEmail from './TheHeaderDropdownEmail';
// import TheHeaderDropdownBell from './TheHeaderDropdownBell';

// import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  name: 'TheContainer',
  components: {
   // TheSidebar,
    TheHeader,
    TheFooter,
    TheHeaderDropdownAccnt,
    TheHeaderDropdownEmail,
    TheHeaderDropdownBell
  }
}
</script>
-->
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
img.c-sidebar-brand-full {
  width: 150px !important;
  height: inherit !important;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


<script>
import nav from "./_nav";
console.log("nav exported ::: ", nav);
// import nav from "@/containers/_nav";
import { SemipolarSpinner } from "epic-spinners";

import {
  // TheSidebar,
  //TheHeader,
  // TheFooter,
  // TheHeaderDropdownAccnt,
  // TheHeaderDropdownEmail,
  // TheHeaderDropdownBell,
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  //Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import store from "../store";

import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownEmail from "./TheHeaderDropdownEmail";

// import TheSidebar from './TheSidebar'
// import TheHeader from './TheHeader'
import TheFooter from "./TheFooter";

export default {
  name: "TheContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    // TheSidebar,
    // TheHeader,
    TheFooter,
    TheHeaderDropdownAccnt,
    TheHeaderDropdownEmail,
    SemipolarSpinner,
  },

  data() {
    return {
      // nav: nav.items
      nav: [],
      isLoading: false,
    };
  },
  mounted() {
    this.nav = store.getters.getNavs;
    // console.log("store.getters.getNavs" , this.nav);
    // console.log("this.$route :::::::", this.$route, this.nav);
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
    show() {
      // console.log("this.$store ::::: ", this.$store.state);
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  methods: {
    cambiarMenu(opcion) {
      this.isLoading = true;
      // console.log("opcion", store.getters.getNavs);
      store.dispatch("changeNavs", opcion).then(() => {
        this.nav = store.getters.getNavs;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style>
.mobileheaderlink {
  display: none;
}
.c-sidebar-brand-minimized {
  width: 90%;
  height: auto;
}

@media screen and (max-width: 991px) {
  .mobileheaderlink {
    /* 
    margin: 0 auto; */
    padding: 10px 0;
    width: 100%;
    display: block;
    text-align: center;
  }
  .mobileheaderlink .nav-pills {
    display: inline-flex;
  }
}

@media screen and (max-width: 1000px) {
  .navbar-brand-xs {
    display: none;
  }
  .navbar-brand-full {
    width: 50% !important;
    height: auto;
    display: block;
  }
}
@media screen and (max-width: 467px) {
  .navbar-brand-full {
    display: none;
  }
  .navbar-brand-xs {
    display: block;
    width: 60px;
    height: auto;
  }
}
@media screen and (max-width: 330px) {
  .mobileheaderlink .nav-pills li {
    padding: 5px !important;
  }
  .mobileheaderlink .nav-pills li a {
    padding: 5px 10px;
  }
}

/* Sidebar Fix */
@media only screen and (min-width: 992px) {
  .c-sidebar-minimized .c-sidebar-nav {
    margin-bottom: 100px;
  }
  .c-sidebar-minimized .c-sidebar-nav-settings {
    position: fixed;
    bottom: 52px;
    background: #3c4b64;
    width: 55px;
  }
}
</style>